import { render } from "./TipPoolTipForm.vue?vue&type=template&id=35f82bb0"
import script from "./TipPoolTipForm.vue?vue&type=script&lang=js"
export * from "./TipPoolTipForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__